/**
 * The shared static logo card impression enrichment
 */
export const STATIC_LOGO_CARD_ENRICHMENT = {
    group: 'users_impressions',
    sub_group: 'content_impression',
    action: { type: 'impression' }
};

export const REMOVE_TAGS_KEYCODES = [
    8 // Backspace
];
